import { useParams } from 'react-router-dom';
import { Grid, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { message } from 'antd';
import { findAllByGroupDetailsOrderEvent, findOrdersByClientEvent } from '../../../../_events/orders/find_order.event';
import InfoOrderModal from './modals/info_order_modal';
import ModalCutInfo from './modals/info_cut_modal';
import { updateOrderDetailEvent, viewInfoDetailsEvent } from '../../../../_events/orderDetail/orderDetail.event';
import TableOrders from './client_order_list';
import UpdateOrderDetailModal from './modals/update_orderDetail_modal';
import { findAllColors } from "../../../../_events/color/find_colors.event";
import { findAllProcessStateEvent } from "../../../../_events/process_state/find_process_state.event";
import { findProductsPriceByClientEvent } from '../../../../_events/products/findProducts.event';
import UpdateOrderModal from './modals/update_order_modal';
import { editOrderEvent } from '../../../../_events/orders/edit.event';
import { deleteOrdersEvent } from '../../../../_events/orders/order_box.event';

const inputStyle = {
  padding: "8px",
  borderRadius: "4px",
  border: "1px solid #ccc",
  marginRight: "10px",
  fontSize: "14px",
  width: "200px",
  outline: "none",
};

const ClientOrders = () => {

  let { uuid } = useParams();
  const [filteredOrders, setFilteredOrders] = useState(null);
  const [filaExpandida, setFilaExpandida] = useState(null);

  const [orders, setOrders] = useState(null);

  const [order, setOrder] = useState(null);
  const [openModalOrder, setOpenModalOrder] = useState(false);

  const [cutInfo, setCutInfo] = useState(null);
  const [openCutModal, setOpenCutModal] = useState(false);

  const [orderDetailUpdate, setOrderDetailUpdate] = useState(false);
  const [openUpdateODModal, setOpenUpdateODModal] = useState(false);

  const [processList, setProcessList] = useState(null);
  const [colorList, setColorList] = useState(null);
  const [productPriceList, setProductPriceList] = useState(null);

  const [orderUpdate, setOrderUpdate] = useState(null);
  const [openModalEditOrder, setOpenModalEditOrder] = useState(null);

  const findOrdersByClient = () => {
    findOrdersByClientEvent(uuid)
      .then((data) => {
        setOrders(data.list);
      })
      .catch((err) => {
        message.err(err);
      });
  };

  const filterOrders = (filterValue) => {
    const filter = orders
      ? orders.filter((order) =>
        order.id.toLowerCase().includes(filterValue.toLowerCase())
      )
      : [];

    setFilteredOrders(filter);
  }

  const editOrder = (uuid_order) => {
    setOpenModalOrder(true);
    findAllByGroupDetailsOrderEvent(uuid_order)
      .then((data) => {
        setOrder(data.list);
      })
      .catch((err) => {
        setOpenModalOrder(false);
        message.error(err.message);
      });
  }

  const handleCloseCutModal = () => {
    setCutInfo(null);
    setOpenCutModal(false);
  }

  const handleCloseModalOrder = () => {
    setOrder(null);
    setOpenModalOrder(false);
  }

  const handleCloseUpdateOrderDetail = () => {
    setOpenUpdateODModal(false);
    setOrderDetailUpdate(null);
    setOpenModalOrder(false);
    setOpenCutModal(false);
    setColorList(null);
    setProcessList(null);
    setProductPriceList(null);
  };

  const searchCutInfo = (uuid_details) => {
    viewInfoDetailsEvent(uuid_details)
      .then(data => {
        setOpenCutModal(true);
        setCutInfo(data.data);
      }).catch((err) => {
        setOpenCutModal(false);
        message.error(err);
      })
  }

  const editOrderDetail = (orderDetail) => {
    setOpenUpdateODModal(true);
    findAllColors()
      .then((data) => {
        setColorList(data.list);
      })
      .catch((err) => {
        message.error(err)
      })
    findAllProcessStateEvent()
      .then((data) => {
        setProcessList(data.list);
      })
      .catch((err) => {
        message.error(err)
      })

    findProductsPriceByClientEvent(orderDetail.productPrice.client.uuid)
      .then((data) => {
        setProductPriceList(data.list)
      })
      .catch((err) => {
        message.error(err)
      })
    setOrderDetailUpdate(orderDetail);
  }

  const updateOrderDetail = (dataUpdate) => {
    updateOrderDetailEvent(dataUpdate, orderDetailUpdate)
      .then((data) => {
        handleCloseUpdateOrderDetail();
        if (!data.ok) {
          message.error('Error en la actualizacion')
        } else {
          message.success('Registro actualizado')
        }
      })
      .catch((err) => {
        alert(err.message);
        setOpenUpdateODModal(false);
      })
  }

  const manejarClickFila = (id) => {
    setFilaExpandida(filaExpandida === id ? null : id);
  };

  const handleOpenModalEditOrder = (order) => {
    setOrderUpdate(order);
    setOpenModalEditOrder(true);
  }

  const handleCloseModalEditOrder = () => {
    setOpenModalEditOrder(false);
    setOrderUpdate(false)
  }

  const updateOrder = (inputs) => {
    editOrderEvent(orderUpdate.uuid, inputs)
      .then((data) => {
        handleCloseModalEditOrder();
        handleCloseModalOrder();
        message.success('Orden editada')
      })
      .catch((err) => {
        message.err(err);
      });

  }

  const deleteOrder = (uuid_order) => {
    deleteOrdersEvent(uuid_order)
      .then(data => {
        message.success('Orden eliminada');
        findOrdersByClient();
        handleCloseModalOrder();
      })
      .catch(err => {
        message.error(err.message);
      });
  }

  useEffect(() => {
    findOrdersByClient();
  }, []);


  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <Typography variant="h6" component="h6">
            Historial de pedidos
          </Typography>
        </div>
        <hr />
        {!orders ? 'Cargando...' : (
          <div>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "12px", flexDirection: "row-reverse" }}>
              <input
                type="text"
                placeholder="Buscar orden"
                style={inputStyle}
                onChange={(e) => filterOrders(e.target.value)}
              />
              <p style={{ marginRight: "10px" }}>No. orden a buscar:</p>
            </div>

            <TableOrders
              orders={!filteredOrders ? orders : filteredOrders}
              editOrder={(order_uuid) => editOrder(order_uuid)}
              setFilaExpandida={(obj) => setFilaExpandida(obj)}
              filaExpandida={filaExpandida}
              manejarClickFila={(id) => manejarClickFila(id)}
            />
          </div>
        )}

      </Grid>

      {
        !order ? null :
          (
            <InfoOrderModal
              openModalOrder={openModalOrder}
              order={order}
              handleCloseModalOrder={handleCloseModalOrder}
              searchCutInfo={(uuid_details) => searchCutInfo(uuid_details)}
              editOrder={(order) => handleOpenModalEditOrder(order)}
              deleteOrder={(uuid_order) => deleteOrder(uuid_order)}
            />
          )
      }

      {
        !cutInfo ? null :
          (
            <ModalCutInfo
              cutInfo={cutInfo}
              openCutModal={openCutModal}
              handleCloseCutModal={handleCloseCutModal}
              editOrderDetail={(od) => (editOrderDetail(od))}
            />
          )

      }

      {
        !orderDetailUpdate ? null :
          (
            <UpdateOrderDetailModal
              openUpdateODModal={openUpdateODModal}
              orderDetailUpdate={orderDetailUpdate}
              handleCloseUpdateOrderDetail={handleCloseUpdateOrderDetail}
              updateOrderDetail={(body) => updateOrderDetail(body)}
              processList={processList}
              colorList={colorList}
              productPriceList={productPriceList}
            />
          )

      }

      {
        !orderUpdate ? null :
          (
            <UpdateOrderModal
              order={orderUpdate}
              handleCloseModalEditOrder={handleCloseModalEditOrder}
              openModalEditOrder={openModalEditOrder}
              updateOrder={(inputs) => updateOrder(inputs)}
            />
          )
      }

    </Grid>
  );
}

export default ClientOrders;
